import { Show } from "solid-js";
import ListLoader from "./ListLoader";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/shadcn/table";
import { TableAction } from "./TableAction";
import { TableViewRow } from "./TableViewRow";
import { TableViewHead } from "./TableViewHead";

export const TableView = (props) => {

  const render = (row, cell) => {
    if (cell.render && typeof cell.render === "function") {
      return <div class={cell.sort ? "ps-3" : ""}>{cell.render(row)}</div>;
    }

    return <div class={cell.sort ? "ps-3" : ""}>{row[cell.key]}</div>;
  }

  const columnsCount = () => {
    return props.columns.length + (props.actions.actions.length > 0 ? 1 : 0);
  }

  return (
    <div class="rounded-md border">
      <Table class={props.class ?? ''}>
        <TableHeader>
          <TableRow>
            <Show when={props.actions.actions.length > 0}>
              <TableHead>
                <TableAction actions={props.actions.actions} items={props.data.length} checkedItems={props.checkedItems} onAction={props.actions.onBulkAction} onCheck={props.actions.onListCheckChange} />
              </TableHead>
            </Show>
            <For each={props.columns}>
              {(header) => <TableViewHead header={header} />}
            </For>
          </TableRow>
        </TableHeader>
        <TableBody>
          <Show when={props.loading}>
            <TableRow>
              <TableCell colSpan={props.columns.length} class="h-24 text-center">
                <ListLoader outerColor="#8841B2" innerColor="#8841B2" />
              </TableCell>
            </TableRow>
          </Show>
          <Show when={!props.loading && props.data?.length === 0}>
            <TableRow>
              <TableCell colSpan={columnsCount()} class="h-24 text-center">
                No results.
              </TableCell>
            </TableRow>
          </Show>
          <Show when={!props.loading && props.data?.length !== 0}>
            <For each={props.data}>
              {(row) => (
                <TableViewRow action={props.actions.actions.length > 0} move={props.move} key={row.key} items={props.checkedItems} onToggle={props.onRowCheck}>
                  <For each={props.columns}>
                    {(cell) => (
                      <TableCell>
                        {render(row, cell)}
                      </TableCell>
                    )}
                  </For>
                </TableViewRow>
              )}
            </For>
          </Show>
        </TableBody>
      </Table>
    </div>
  );
}
